import Vue from 'vue'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import auth from './modules/auth'
import registration from './modules/registration'
import adminPanel from './modules/admin-panel'
import booking from './modules/booking'
import candidate from './modules/candidate'
import candidateSettings from './modules/candidate-settings'
import jobManagement from './modules/job-management'
import jobSearch from './modules/job-search'
import jobCode from './modules/jobcode'
import jobAd from './modules/jobad'
import inbox from './modules/inbox'
import closeup from './modules/closeup'
import businessProfile from './modules/business-profile'
import recruitingSearch from './modules/recruitingSearch'
import candidateManagement from './modules/candidate-management'
import recruiterSettings from './modules/recruiter-settings'
import showroom from './modules/showroom'
import progressflow from './modules/progressFlow'
import VuexPersistence from 'vuex-persist'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'development'
const vuexLocalStorage = new VuexPersistence({
  reducer: state => ({
    jobCodeModule: {
      interviewTracking: state.jobCodeModule.interviewTracking,
      skipBtn: state.jobCodeModule.skipBtn,
    },
    authModule: {
      userInfo: state.authModule.userInfo,
    },
  }),
})

const store = new Vuex.Store({
  modules: {
    authModule: auth,
    booking: booking,
    registrationModule: registration,
    adminPanelModule: adminPanel,
    candidateSettingsModule: candidateSettings,
    recruiterSettingsModule: recruiterSettings,
    candidateManagementModule: candidateManagement,
    candidateModule: candidate,
    jobManagementModule: jobManagement,
    businessProfileModule: businessProfile,
    jobSearchModule: jobSearch,
    jobCodeModule: jobCode,
    jobAdModule: jobAd,
    inboxModule: inbox,
    closeupModule: closeup,
    showroomModule: showroom,
    RSModule: recruitingSearch,
    pfModule: progressflow,
  },
  plugins: [vuexLocalStorage.plugin],
  strict: debug,
})

Vue.use(vuexI18n.plugin, store)
// add translations directly to the application
Vue.i18n.add('en', require('@/lang/en.json'))
Vue.i18n.add('de', require('@/lang/de.json'))
Vue.i18n.add('fr', require('@/lang/fr.json'))

export default store
